import React, { useContext } from "react";
import styles from "./FloatingWidgets.module.css";
// import "./template.css";
import PrizeDetilsWidgets from "./PrizeDetilsWidgets";
import TimerWidget from "./TimerWidget";
import TimerWidget2 from "./TimerWidget2";
import EventFacts from "./EventFacts";
import Context from "../../context/Context";
import OverView from "./OverView";
import { isEmpty } from "lodash";
export default function FloatingWidgets({
  page,
  prize,
  endTime,
  color,
  bgColor,
}) {
  const { campaignSpecs } = useContext(Context);
  return (
    <div className={styles.widgetBg}>
      <div className={styles.container}>
        <div className="w-full h-full relative">
          {/* {prize && (
            <PrizeDetilsWidgets
              page={page}
              prize={prize}
              color={color}
              bgColor={bgColor}
            />
          )} */}

          {/* {endTime && (
            <TimerWidget
              page={page}
              endTime={endTime}
              color={color}
              bgColor={bgColor}
            />
          )} */}
          {endTime && !isEmpty(campaignSpecs) && (
            <TimerWidget2 page={page} endTime={endTime} />
          )}
          {campaignSpecs?.eventFacts && (
            <EventFacts data={campaignSpecs?.eventFacts} />
          )}
          {campaignSpecs?.overview?.items && (
            <OverView data={campaignSpecs?.overview} />
          )}
        </div>
      </div>
    </div>
  );
}
